module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/legend.61a93c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/legend.jpg
// module id = 68go
// module chunks = 0